import React, { useEffect, useState } from 'react';

import axios from 'axios';

import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import config from '../../config';

import Progressbar from './Progressbar';

const FinalSubmission = () => {
  const navigate = useNavigate();

  const { repoId } = useParams();

  const decodedRepoId = repoId ? atob(repoId) : '';

  const userId = useSelector((state) => state.userInfo.id);
  console.log(userId);

  const API_SERVER = config.API_BASE_URL;

  const [loading, setLoading] = useState(true);

  const [postLoading, setPostLoading] = useState(false);

  const [repoData, setRepoData] = useState(null);

  const [repoCurrentStep, setRepoCurrentStep] = useState('Pending');

  useEffect(() => {
    getRepoData();
    fetchRepoProgress();
  }, []);

  const getRepoData = async () => {
    try {
      const res = await axios.get(`${API_SERVER}getVehicleRepoById/${decodedRepoId}`);

      if (res.data.status && res.data.data) {
        setRepoData(res.data.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchRepoProgress = async () => {
    try {
      const res = await axios.get(`${API_SERVER}get-repo-progress-flow?repo_id=${decodedRepoId}`);

      if (res.data.status) {
        setRepoCurrentStep(res.data.current_step);

        console.table(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    setPostLoading(true);

    try {
      const payload = new FormData();

      payload.append('repo_id', decodedRepoId);

      payload.append('created_by', userId);

      payload.append('updated_by', userId);

      const res = await axios.post(`${API_SERVER}submitFinalInventory`, payload);

      if (res.data.status) {
        toast.success('Vehicle submitted successfully');

        navigate('/dashboard/vehicle-repo-list');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Something went wrong');
    } finally {
      // --- PRELOADER: hide overlay after POST finishes ---
      setPostLoading(false);
    }
  };

  if (loading) {
    return <div className="container-fluid">Loading...</div>;
  }

  return (
    <div className="container-fluid">
      {/* --- PRELOADER OVERLAY: shown during POST request --- */}
      {postLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(3px)',
          }}
        >
          <div
            style={{
              width: '56px',
              height: '56px',
              border: '5px solid #e0e0e0',
              borderTop: '5px solid #198754',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
            }}
          />
          <p style={{ marginTop: '18px', fontWeight: 600, color: '#198754', fontSize: '15px' }}>
            Submitting, please wait...
          </p>
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                width: '320px',
                height: '14px',
                borderRadius: '6px',
                marginTop: '10px',
                background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
                backgroundSize: '400% 100%',
                animation: 'shimmer 1.4s infinite',
              }}
            />
          ))}
          <style>{`
            @keyframes spin { to { transform: rotate(360deg); } }
            @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
          `}</style>
        </div>
      )}
      {/* --- END PRELOADER OVERLAY --- */}

      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="mb-4">Final Submission</h4>

          <div className="mb-4">
            {/* <Progressbar
            currentStep={repoCurrentStep}
          /> */}
          </div>

          <div className="row">
            <div className="col-md-12 mb-3">
              <h5 className="border-bottom pb-2">Vehicle Details</h5>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Agreement No</label>

              <div>{repoData?.agreement_no || '-'}</div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Make</label>

              <div>{repoData?.make || '-'}</div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Model</label>

              <div>{repoData?.model || '-'}</div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Registration Number</label>

              <div>{repoData?.registration_number || '-'}</div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Vehicle Year</label>

              <div>{repoData?.vehicle_year || '-'}</div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Mileage</label>

              <div>{repoData?.mileage || '-'}</div>
            </div>

            <div className="col-md-12 mt-4 mb-3">
              <h5 className="border-bottom pb-2">Customer Details</h5>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Customer Name</label>

              <div>{repoData?.customer_name || '-'}</div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="fw-bold">Mobile Number</label>

              <div>{repoData?.mobile || '-'}</div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
                  Back
                </button>

                {/* --- PRELOADER: button disabled while POST is in-flight --- */}
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleSubmit}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalSubmission;
